/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IxModule} from '@siemens/ix-angular';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {BaseFormFieldDirective} from '../../base-form-field.directive';
import {FieldLabelComponent} from '../field-label/field-label.component';

@Component({
  selector: 'app-text-input',
  imports: [
    CommonModule,
    IxModule,
    ReactiveFormsModule,
    TranslateModule,
    FieldLabelComponent,
  ],
  templateUrl: './text-input.component.html',
  styleUrl: '../input-components.scss',
})
export class TextInputComponent extends BaseFormFieldDirective {
  constructor() {
    super();
  }
}
